import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { HttpService } from "../services/http.service";
import { AmplifyService } from "../services/amplify.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-help-centre",
  templateUrl: "./help-centre.page.html",
  styleUrls: ["./help-centre.page.scss"],
})
export class HelpCentrePage implements OnInit {
  videos = [
    { id: "7_vQOAy4msI", title: "Getting Started with Arii Connect", category: "General" },
    { id: "DaNT6fzhwWY", title: "Adding and Deleting Folders & Resources", category: "Advanced" },
    { id: "PnapKUEYJV8", title: "Editing Button Designs in Arii Connect", category: "Design" },
    // { id: "vnM1B49Rwjo", title: "Creating Access Points in Arii Connect", category: "General" },
    { id: "WmGDKHPqn0w", title: "Canva Templates for Arii Connect", category: "Technical" },
  ];
  activeVideo: string | null = null;
  constructor(
    public app: AppService,
    private http: HttpService,
    public amplify: AmplifyService,
    private router: Router,
    public title: Title,
    private platform: Platform,
    private sanitizer: DomSanitizer
  ) {
    if (!this.app.sysData.isLoggedIn) {
      this.router.navigateByUrl("/login");
    }
  }
  showVideo(videoId: string) {
    this.activeVideo = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
  }

  hideVideo() {
    this.activeVideo = null;
  }

  ngOnInit() {
    this.title.setTitle("Arii Connect Help Centre");
  }
}
